import { makeStyles } from 'src/utils/makeStyles';

export const globalStyles = makeStyles({
  '._pendo-resource-center-badge-container': {
    '@media print': {
      display: 'none !important',
    },
  },
});
